import gql from 'graphql-tag'

export const REFRESH_ACCOUNT = gql`
  query RefreshAccount {
    refreshStripeAccountUser {
      id
      stripeAccount {
        id
        chargesEnabled
      }
    }
  }
`